export default "__VITE_ASSET__CsaK2fmW__"